export const subscriptionChannels = {
  methods: {
    isGlifeOnly() {
      let status = 0;
      Object.keys(this.planChannels).forEach(key => {
        if (key === 'enable_glife' && !!this.planChannels[key]) status = true;
        else if (key !== 'enable_glife' && !!this.planChannels[key]) status = false;
      });
      return status;
    }
  }
};
